// Auth
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SET_USER_SETTING = 'SET_USER_SETTING';
export const SET_RESTORE_LOGIN = 'SET_RESTORE_LOGIN';
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';
export const SIGN_IN_LOADING_STATUS = 'SIGN_IN_LOADING_STATUS';

// Games
export const FETCH_GAMES = 'FETCH_GAMES';
export const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER';
export const SET_SELECTED_GAME = 'SET_SELECTED_GAME';
export const SET_FAVORITE_GAMES = 'SET_FAVORITE_GAMES';
export const SET_SELECTED_GAME_ID = 'SET_SELECTED_GAME_ID';
export const SET_GAMES_RTP_WITH_ID = 'SET_GAMES_RTP_WITH_ID';
export const FETCH_GAMES_CATEGORIES = 'FETCH_GAMES_CATEGORIES';
export const SET_CATEGORIES_LOADING_STATUS = 'SET_CATEGORIES_LOADING_STATUS';
export const SET_CASINO_GAMES_LOADING_STATUS = 'SET_CASINO_GAMES_LOADING_STATUS';

// Popups and Dialogs
export const OPEN_POPUP = 'OPEN_POPUP';
export const CLOSE_POPUP = 'CLOSE_POPUP';
export const CLOSE_ALL_POPUPS = 'CLOSE_ALL_POPUPS';
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const CLOSE_ALL_DIALOGS = 'CLOSE_ALL_DIALOGS';

// UI
export const IS_MOBILE = 'IS_MOBILE';
export const CURRENT_THEME = 'CURRENT_THEME';
export const OPEN_DEPOSIT_TAB = 'OPEN_DEPOSIT_TAB';
export const CLOSE_DEPOSIT_TAB = 'CLOSE_DEPOSIT_TAB';
export const NAVIGATION_OPENED = 'NAVIGATION_OPENED';
export const NAVIGATION_CLOSED = 'NAVIGATION_CLOSED';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const NAVIGATION_SECTION_CLOSED = 'NAVIGATION_SECTION_CLOSED';
export const NAVIGATION_SECTION_OPENED = 'NAVIGATION_SECTION_OPENED';

// Others
export const SET_ERROR = 'SET_ERROR';
export const SET_DBET_DATA = 'SET_DBET_DATA';
export const SET_WALLET_NAME = 'SET_WALLET_NAME';
export const SET_PROVIDER_DATA = 'SET_PROVIDER_DATA';
export const IS_DBET_LOADED = 'IS_DBET_LOADED';
export const SET_TRANSACTION = 'SET_TRANSACTION';
export const SET_BANNERS_DATA = 'SET_BANNERS_DATA';
export const FETCH_BANNERS_DATA = 'FETCH_BANNERS_DATA';
export const WAIT_FOR_TRANSACTION = 'WAIT_FOR_TRANSACTION';
export const SET_FINAL_TRANSACTION = 'SET_FINAL_TRANSACTION';
export const SET_CONTRACT_TRANSACTION = 'SET_CONTRACT_TRANSACTION';
export const SET_BANNERS_LOADING_STATUS = 'SET_BANNERS_LOADING_STATUS';
export const SET_METAMASK_NETWORK_ERROR = 'SET_METAMASK_NETWORK_ERROR';
